import CloseIcon from "@/components/icons/CloseIcon";
import Loading from "@/components/global/Loading";
import Input from "../../Input";

import { Formik, Form } from "formik";
import { getCookie, setCookie } from "cookies-next";
import { useTranslation } from "next-i18next";
import { otpValidation } from "@/utils/valitation/auth";
import { useBodyScrollLock } from "@/hooks/useBodyScrollLock";

const OtpEmail = ({ Context }) => {
  const { t } = useTranslation("common");
  const email = getCookie("email");
  
  const handleSubmit = async (values) => {
    setCookie("otpEmail", values.otp);
    
    Context?.dispatch({ type: "auth" });
    Context?.dispatch({ type: "changePassByEmail" });
    
  };

  useBodyScrollLock();
  return (
    <div className="w-11/12 mx-auto min-[450px]:w-[450px] p-3.5 bg-white rounded-md">
      <div className="flex items-center justify-between pb-2 border-b">
        <h2 className="font-bold sm:text-xl">{t("Verify Otp")}</h2>
        <CloseIcon
          onClick={() => Context?.dispatch({ type: "otpEmail" })}
          className="cursor-pointer text-secondary-800 size-3"
        />
      </div>
      <p className="my-2 text-center max-sm:text-sm">
        <span className="font-bold text-secondary-800">
          {t("OTP verification")}{" "}
        </span>
        <span className="mx-1 text-zinc-500">
          {t("verify OTP that send to your email")}: {email}
        </span>
      </p>
      <Formik
        onSubmit={(values, { setSubmitting, setFieldError }) => {
          handleSubmit(values, setSubmitting, setFieldError);
        }}
        initialValues={{ otp: "" }}
        validationSchema={otpValidation(t)}
      >
        {({ isSubmitting }) => (
          <Form>
            <Input
              placeholder={t("Otp")}
              name="otp"
              dir="ltr"
              inputClassName="p-1.5 max-sm:placeholder:text-sm max-sm:text-sm rounded-sm w-full border outline-none"
              t={t}
            />
            <button
              className="mt-1 max-sm:text-sm bg-primary text-white p-1.5 rounded-sm w-full font-semibold uppercase"
              type="submit"
            >
              {isSubmitting ? <Loading /> : t("Send Code")}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default OtpEmail;
